import { useCurrency } from 'contexts/CurrencyProvider';
import { DISCOUNT_DISCOUNT_TYPE } from 'modules/sales-offer/common/constants/offer.type.enum';
import { memo } from 'react';

type Props = { data: any };

const ProductDiscountCell = ({ data }: Props) => {
  const { primary } = useCurrency();

  if (!data?.value) return <>-</>;

  return (
    <>
      - {data?.value}{' '}
      {data?.type === DISCOUNT_DISCOUNT_TYPE.FIXED ? primary : ' %'}
    </>
  );
};

export default memo(ProductDiscountCell);
